module.exports = "<component :is=duplicate.type :fdata.sync=duplicate :dispatch=dispatch :paste=paste> </component>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/inputs/text/duplicate.vue
// module id = 454
// module chunks = 0